export default __webpack_public_path__ + "static/media/2_am.07660e36.mp3";